export const componentTree = [
  {
    text: "Algebra",
    items: [
      {
        text: "derivative(expr, x, <options>)",
        math: "derivative",
        expressionText: "derivative( , , )",
      },
      {
        text: "intercept(xValues, yValues)",
        math: "intercept",
        expressionText: "intercept( , )",
      },
      {
        text: "leafCount(expr)",
        math: "leafCount",
        expressionText: "leafCount( )",
      },
      {
        text: "lsolve(L, b)",
        math: "lsolve",
        expressionText: "lsolve( , )",
      },
      {
        text: "lsolveAll(L, b)",
        math: "lsolveAll",
        expressionText: "lsolveAll( , )",
      },
      {
        text: "lup(A)",
        math: "lup",
        expressionText: "lup( )",
      },
      {
        text: "lusolve(A, b)",
        math: "lusolve",
        expressionText: "lusolve( , )",
      },
      {
        text: "lyap(A, Q)",
        math: "lyap",
        expressionText: "lyap( , )",
      },
      {
        text: "polynomialRoot(constant, linearCoeff, quadraticCoeff, cubicCoeff)",
        math: "polynomialRoot",
        expressionText: "polynomialRoot( , , , )",
      },
      {
        text: "qr(A)",
        math: "qr",
        expressionText: "qr( )",
      },
      {
        text: "rationalize(expr)",
        math: "rationalize",
        expressionText: "rationalize( )",
      },
      {
        text: "resolve(expr, scope)",
        math: "resolve",
        expressionText: "resolve( , )",
      },
      {
        text: "schur(A)",
        math: "schur",
        expressionText: "schur( )",
      },
      {
        text: "simplify(expr)",
        math: "simplify",
        expressionText: "simplify( )",
      },
      {
        text: "simplifyConstant(expr)",
        math: "simplifyConstant",
        expressionText: "simplifyConstant( )",
      },
      {
        text: "simplifyCore(expr)",
        math: "simplifyCore",
        expressionText: "simplifyCore( )",
      },
      {
        text: "slope(xValues, yValues)",
        math: "slope",
        expressionText: "slope( , )",
      },
      {
        text: "slu(A, order, threshold)",
        math: "slu",
        expressionText: "slu( , , )",
      },
      {
        text: "sylvester(A, B, C)",
        math: "sylvester",
        expressionText: "sylvester( , , )",
      },
      {
        text: "symbolicEqual(expr1, expr2)",
        math: "symbolicEqual",
        expressionText: "symbolicEqual( , )",
      },
      {
        text: "usolve(U, b)",
        math: "usolve",
        expressionText: "usolve( , )",
      },
      {
        text: "usolveAll(U, b)",
        math: "usolveAll",
        expressionText: "usolveAll( , )",
      },
    ],
  },
  {
    text: "Arithmetic",
    items: [
      {
        text: "abs(x)",
        math: "abs",
        expressionText: "abs( )",
      },
      {
        text: "add(x, y)",
        math: "add",
        expressionText: "add( , )",
      },
      {
        text: "cbrt(x [, allRoots])",
        math: "cbrt",
        expressionText: "cbrt( )",
      },
      {
        text: "ceil(x)",
        math: "ceil",
        expressionText: "ceil( )",
      },
      {
        text: "cube(x)",
        math: "cube",
        expressionText: "cube( )",
      },
      {
        text: "divide(x, y)",
        math: "divide",
        expressionText: "divide( , )",
      },
      {
        text: "dotDivide(x, y)",
        math: "dotDivide",
        expressionText: "dotDivide( , )",
      },
      {
        text: "dotMultiply(x, y)",
        math: "dotMultiply",
        expressionText: "dotMultiply( , )",
      },
      {
        text: "dotPow(x, y)",
        math: "dotPow",
        expressionText: "dotPow( , )",
      },
      {
        text: "exp(x)",
        math: "exp",
        expressionText: "exp( )",
      },
      {
        text: "expm1(x)",
        math: "expm1",
        expressionText: "expm1( )",
      },
      {
        text: "fix(x)",
        math: "fix",
        expressionText: "fix( )",
      },
      {
        text: "floor(x)",
        math: "floor",
        expressionText: "floor( )",
      },
      {
        text: "gcd(a, b)",
        math: "gcd",
        expressionText: "gcd( , )",
      },
      {
        text: "hypot(a, b, ...)",
        math: "hypot",
        expressionText: "hypot( , , )",
      },
      {
        text: "invmod(a, b)",
        math: "invmod",
        expressionText: "invmod( , )",
      },
      {
        text: "lcm(aL, b)",
        math: "lcm",
        expressionText: "lcm( , )",
      },
      {
        text: "log(x [, base])",
        math: "log",
        expressionText: "log( )",
      },
      {
        text: "log10(x)",
        math: "log10",
        expressionText: "log10( )",
      },
      {
        text: "log1p(x)",
        math: "log1p",
        expressionText: "log1p( )",
      },
      {
        text: "log2(x)",
        math: "log2",
        expressionText: "log2( )",
      },
      {
        text: "mod(x, y)",
        math: "mod",
        expressionText: "mod( , )",
      },
      {
        text: "multiply(x, y)",
        math: "multiply",
        expressionText: "multiply( , )",
      },
      {
        text: "norm(x [, p])",
        math: "norm",
        expressionText: "norm( )",
      },
      {
        text: "nthRoot(a)",
        math: "nthRoot",
        expressionText: "nthRoot( )",
      },
      {
        text: "nthRoots(x)",
        math: "nthRoots",
        expressionText: "nthRoots( )",
      },
      {
        text: "pow(x, y)",
        math: "pow",
        expressionText: "pow( , )",
      },
      {
        text: "round(x [, n])",
        math: "round",
        expressionText: "round( )",
      },
      {
        text: "sign(x)",
        math: "sign",
        expressionText: "sign( )",
      },
      {
        text: "sqrt(x)",
        math: "sqrt",
        expressionText: "sqrt( )",
      },
      {
        text: "square(x)",
        math: "square",
        expressionText: "square( )",
      },
      {
        text: "subtract(x, y)",
        math: "subtract",
        expressionText: "subtract( , )",
      },
      {
        text: "unaryMinus(x)",
        math: "unaryMinus",
        expressionText: "unaryMinus( )",
      },
      {
        text: "unaryPlus(x)",
        math: "unaryPlus",
        expressionText: "unaryPlus( )",
      },
      {
        text: "xgcd(a, b)",
        math: "xgcd",
        expressionText: "xgcd( , )",
      },
    ],
  },
  {
    text: "Bitwise",
    items: [
      {
        text: "bitAnd(x, y)",
        math: "bitAnd",
        expressionText: "bitAnd( , )",
      },
      {
        text: "bitNot(x)",
        math: "bitNot",
        expressionText: "bitNot( )",
      },
      {
        text: "bitOr(x, y)",
        math: "bitOr",
        expressionText: "bitOr( , )",
      },
      {
        text: "bitXor(x, y)",
        math: "bitXor",
        expressionText: "bitXor( , )",
      },
      {
        text: "leftShift(x, y)",
        math: "leftShift",
        expressionText: "leftShift( , )",
      },
      {
        text: "rightArithShift(x, y)",
        math: "rightArithShift",
        expressionText: "rightArithShift( , )",
      },
      {
        text: "rightLogShift(x, y)",
        math: "rightLogShift",
        expressionText: "rightLogShift( , )",
      },
    ],
  },
  {
    text: "Combinatorics",
    items: [
      {
        text: "bellNumbers(n)",
        math: "bellNumbers",
        expressionText: "bellNumbers( )",
      },
      {
        text: "catalan(n)",
        math: "catalan",
        expressionText: "catalan( )",
      },
      {
        text: "composition(n, k)",
        math: "composition",
        expressionText: "composition( , )",
      },

      {
        text: "stirlingS2(n, k)",
        math: "stirlingS2",
        expressionText: "stirlingS2( , )",
      },
    ],
  },
  {
    text: "Complex",
    items: [
      {
        text: "arg(x)",
        math: "arg",
        expressionText: "arg( )",
      },
      {
        text: "conj(x)",
        math: "conj",
        expressionText: "conj( )",
      },
      {
        text: "im(x)",
        math: "im",
        expressionText: "im( )",
      },
      {
        text: "re(x)",
        math: "re",
        expressionText: "re( )",
      },
    ],
  },
  {
    text: "Date",
    items: [
      {
        text: "now()",
        math: "now",
        expressionText: "now()",
      },
      {
        text: "today()",
        math: "today",
        expressionText: "today()",
      },
      {
        text: "weekday(date)",
        math: "weekday",
        expressionText: "weekday( )",
      },
      {
        text: "minute(date)",
        math: "minute",
        expressionText: "minute( )",
      },
      {
        text: "hour(date)",
        math: "hour",
        expressionText: "hour( )",
      },
      {
        text: "day(date)",
        math: "day",
        expressionText: "day( )",
      },
      {
        text: "month(date)",
        math: "month",
        expressionText: "month( )",
      },
      {
        text: "addMinutes(date, minutes)",
        math: "addMinutes",
        expressionText: "addMinutes( , )",
      },
      {
        text: "addHours(date, hours)",
        math: "addHours",
        expressionText: "addHours( , )",
      },
      {
        text: "addDays(date, days)",
        math: "addDays",
        expressionText: "addDays( , )",
      },
      {
        text: "addMonths(date, months)",
        math: "addMonths",
        expressionText: "addMonths( , )",
      },
      {
        text: "roundToNextHour(date)",
        math: "roundToNextHour",
        expressionText: "roundToNextHour( )",
      },
      {
        text: "roundToPreviousHour(date)",
        math: "roundToPreviousHour",
        expressionText: "roundToPreviousHour( )",
      },
      {
        text: "dateDif(date1, date2, unit)",
        math: "dateDif",
        expressionText: "dateDif( , , )",
      },
      {
        text: "EOMonth(date, months)",
        math: "EOMonth",
        expressionText: "EOMonth( , )",
      },
    ],
  },
  {
    text: "Geometry",
    items: [
      {
        text: "distance([x1, y1], [x2, y2])",
        math: "distance",
        expressionText: "distance( , )",
      },
      {
        text: (
          <div>
            {"intersect(endPoint1Line1, endPoint2Line1,"}
            <br />
            {"    endPoint1Line2, endPoint2Line2)"}
          </div>
        ),
        math: "intersect",
        expressionText: "intersect( , , , )",
      },
    ],
  },
  {
    text: "Logical",
    items: [
      {
        text: "and(x, y)",
        math: "and",
        expressionText: "and( , )",
      },
      {
        text: "not(x)",
        math: "not",
        expressionText: "not( )",
      },
      {
        text: "or(x, y)",
        math: "or",
        expressionText: "or( , )",
      },
      {
        text: "xor(x, y)",
        math: "xor",
        expressionText: "xor( , )",
      },
    ],
  },
  {
    text: "Matrix",
    items: [
      {
        text: "apply(A, dim, callback)",
        math: "apply",
        expressionText: "apply( , , )",
      },
      {
        text: "column(value, index)",
        math: "column",
        expressionText: "column( , )",
      },
      {
        text: "concat(a, b, c, ... [, dim])",
        math: "concat",
        expressionText: "concat( , )",
      },
      {
        text: "count(x)",
        math: "count",
        expressionText: "count( )",
      },
      {
        text: "cross(x, y)",
        math: "cross",
        expressionText: "cross( , )",
      },
      {
        text: "ctranspose(x)",
        math: "ctranspose",
        expressionText: "ctranspose( )",
      },
      {
        text: "det(x)",
        math: "det",
        expressionText: "det( )",
      },
      {
        text: "diag(x)",
        math: "diag",
        expressionText: "diag( )",
      },
      {
        text: "diff(arr)",
        math: "diff",
        expressionText: "diff( )",
      },
      {
        text: "dot(x, y)",
        math: "dot",
        expressionText: "dot( , )",
      },
      {
        text: "eigs(x, [prec])",
        math: "eigs",
        expressionText: "eigs( )",
      },
      {
        text: "expm(x)",
        math: "expm",
        expressionText: "expm( )",
      },
      {
        text: "fft(arr)",
        math: "fft",
        expressionText: "fft( )",
      },
      {
        text: "filter(x, test)",
        math: "filter",
        expressionText: "filter( )",
      },
      {
        text: "flatten(x)",
        math: "flatten",
        expressionText: "flatten( )",
      },
      {
        text: "forEach(x, callback)",
        math: "forEach",
        expressionText: "forEach( )",
      },
      {
        text: "getMatrixDataType(x)",
        math: "getMatrixDataType",
        expressionText: "getMatrixDataType( )",
      },
      {
        text: "identity(n)",
        math: "identity",
        expressionText: "identity( )",
      },
      {
        text: "ifft(arr)",
        math: "ifft",
        expressionText: "ifft( )",
      },
      {
        text: "inv(x)",
        math: "inv",
        expressionText: "inv( )",
      },
      {
        text: "kron(x, y)",
        math: "kron",
        expressionText: "kron( , )",
      },
      {
        text: "map(x, callback)",
        math: "map",
        expressionText: "map( )",
      },
      {
        text: "matrixFromColumns(...arr)",
        math: "matrixFromColumns",
        expressionText: "matrixFromColumns( )",
      },
      {
        text: "matrixFromFunction(size, fn)",
        math: "matrixFromFunction",
        expressionText: "matrixFromFunction( , )",
      },
      {
        text: "matrixFromRows(...arr)",
        math: "matrixFromRows",
        expressionText: "matrixFromRows( )",
      },
      {
        text: "ones(m, n, p, ...)",
        math: "ones",
        expressionText: "ones( )",
      },
      {
        text: "partitionSelect(x, k)",
        math: "partitionSelect",
        expressionText: "partitionSelect( , )",
      },
      {
        text: "pinv(x)",
        math: "pinv",
        expressionText: "pinv( )",
      },
      {
        text: "range(start, end [, step])",
        math: "range",
        expressionText: "range( , )",
      },
      {
        text: "reshape(x, sizes)",
        math: "reshape",
        expressionText: "reshape( , )",
      },
      {
        text: "resize(x, size [, defaultValue])",
        math: "resize",
        expressionText: "resize( , )",
      },
      {
        text: "rotate(w, theta)",
        math: "rotate",
        expressionText: "rotate( , )",
      },
      {
        text: "rotationMatrix(theta)",
        math: "rotationMatrix",
        expressionText: "rotationMatrix( )",
      },
      {
        text: "row(value, index)",
        math: "row",
        expressionText: "row( , )",
      },
      {
        text: "size(x)",
        math: "size",
        expressionText: "size( )",
      },
      {
        text: "sort(x)",
        math: "sort",
        expressionText: "sort( )",
      },
      {
        text: "sqrtm(A)",
        math: "sqrtm",
        expressionText: "sqrtm( )",
      },
      {
        text: "squeeze(x)",
        math: "squeeze",
        expressionText: "squeeze( )",
      },
      {
        text: "subset(x, index [, replacement])",
        math: "subset",
        expressionText: "subset( , )",
      },
      {
        text: "trace(x)",
        math: "trace",
        expressionText: "trace( )",
      },
      {
        text: "transpose(x)",
        math: "transpose",
        expressionText: "transpose( )",
      },
      {
        text: "zeros(m, n, p, ...)",
        math: "zeros",
        expressionText: "zeros( )",
      },
    ],
  },
  {
    text: "Probability",
    items: [
      {
        text: "combinations(n, k)",
        math: "combinations",
        expressionText: "combinations( , )",
      },
      {
        text: "combinationsWithRep(n, k)",
        math: "combinationsWithRep",
        expressionText: "combinationsWithRep( , )",
      },
      {
        text: "factorial(n)",
        math: "factorial",
        expressionText: "factorial( )",
      },
      {
        text: "gamma(n)",
        math: "gamma",
        expressionText: "gamma( )",
      },
      {
        text: "kldivergence(x, y)",
        math: "kldivergence",
        expressionText: "kldivergence( , )",
      },
      {
        text: "lgamma(n)",
        math: "lgamma",
        expressionText: "lgamma( )",
      },
      {
        text: "multinomial(a)",
        math: "multinomial",
        expressionText: "multinomial( )",
      },
      {
        text: "permutations(n [, k])",
        math: "permutations",
        expressionText: "permutations( )",
      },
      {
        text: "pickRandom(array)",
        math: "pickRandom",
        expressionText: "pickRandom( )",
      },
      {
        text: "random([min, max])",
        math: "random",
        expressionText: "random( , )",
      },
      {
        text: "randomInt([min, max])",
        math: "randomInt",
        expressionText: "randomInt( , )",
      },
    ],
  },
  {
    text: "Relational",
    items: [
      {
        text: "compare(x, y)",
        math: "compare",
        expressionText: "compare( , )",
      },
      {
        text: "compareNatural(x, y)",
        math: "compareNatural",
        expressionText: "compareNatural( , )",
      },
      {
        text: "compareText(x, y)",
        math: "compareText",
        expressionText: "compareText( , )",
      },
      {
        text: "deepEqual(x, y)",
        math: "deepEqual",
        expressionText: "deepEqual( , )",
      },
      {
        text: "equal(x, y)",
        math: "equal",
        expressionText: "equal( , )",
      },
      {
        text: "equalText(x, y)",
        math: "equalText",
        expressionText: "equalText( , )",
      },
      {
        text: "larger(x, y)",
        math: "larger",
        expressionText: "larger( , )",
      },
      {
        text: "largerEq(x, y)",
        math: "largerEq",
        expressionText: "largerEq( , )",
      },
      {
        text: "smaller(x, y)",
        math: "smaller",
        expressionText: "smaller( , )",
      },
      {
        text: "smallerEq(x, y)",
        math: "smallerEq",
        expressionText: "smallerEq( , )",
      },
      {
        text: "unequal(x, y)",
        math: "unequal",
        expressionText: "unequal( , )",
      },
    ],
  },
  {
    text: "Set",
    items: [
      {
        text: "setCartesian(set1, set2)",
        math: "setCartesian",
        expressionText: "setCartesian( , )",
      },
      {
        text: "setDifference(set1, set2)",
        math: "setDifference",
        expressionText: "setDifference( , )",
      },
      {
        text: "setDistinct(set)",
        math: "setDistinct",
        expressionText: "setDistinct( )",
      },
      {
        text: "setIntersect(set1, set2)",
        math: "setIntersect",
        expressionText: "setIntersect( , )",
      },
      {
        text: "setIsSubset(set1, set2)",
        math: "setIsSubset",
        expressionText: "setIsSubset( , )",
      },
      {
        text: "setMultiplicity(element, set)",
        math: "setMultiplicity",
        expressionText: "setMultiplicity( , )",
      },
      {
        text: "setPowerset(set)",
        math: "setPowerset",
        expressionText: "setPowerset( )",
      },
      {
        text: "setSize(set)",
        math: "setSize",
        expressionText: "setSize( )",
      },
      {
        text: "setSymDifference(set1, set2)",
        math: "setSymDifference",
        expressionText: "setSymDifference( , )",
      },
      {
        text: "setUnion(set1, set2)",
        math: "setUnion",
        expressionText: "setUnion( , )",
      },
    ],
  },
  {
    text: "Special",
    items: [
      {
        text: "erf(x)",
        math: "erf",
        expressionText: "erf( )",
      },
    ],
  },
  {
    text: "Statistics",
    items: [
      {
        text: "cumsum(a, b, c, ...)",
        math: "cumsum",
        expressionText: "cumsum( , )",
      },
      {
        text: "mad(a, b, c, ...)",
        math: "mad",
        expressionText: "mad( , )",
      },
      {
        text: "max(a, b, c, ...)",
        math: "max",
        expressionText: "max( , )",
      },
      {
        text: "mean(a, b, c, ...)",
        math: "mean",
        expressionText: "mean( , )",
      },
      {
        text: "median(a, b, c, ...)",
        math: "median",
        expressionText: "median( , )",
      },
      {
        text: "min(a, b, c, ...)",
        math: "min",
        expressionText: "min( , )",
      },
      {
        text: "mode(a, b, c, ...)",
        math: "mode",
        expressionText: "mode( , )",
      },
      {
        text: "prod(a, b, c, ...)",
        math: "prod",
        expressionText: "prod( , )",
      },
      {
        text: "quantileSeq(A, prob [, sorted])",
        math: "quantileSeq",
        expressionText: "quantileSeq( , )",
      },
      {
        text: "std(a, b, c, ...)",
        math: "std",
        expressionText: "std( , )",
      },
      {
        text: "sum(a, b, c, ...)",
        math: "sum",
        expressionText: "sum( , )",
      },
      {
        text: "variance(a, b, c, ...)",
        math: "variance",
        expressionText: "variance( , )",
      },
    ],
  },
  {
    text: "String",
    items: [
      {
        text: "bin(value)",
        math: "bin",
        expressionText: "bin( )",
      },
      {
        text: "format(value [, precision])",
        math: "format",
        expressionText: "format( )",
      },
      {
        text: "hex(value)",
        math: "hex",
        expressionText: "hex( )",
      },
      {
        text: "oct(value)",
        math: "oct",
        expressionText: "oct( )",
      },
      {
        text: "print(template, values [, precision])",
        math: "print",
        expressionText: "print( )",
      },
    ],
  },
  {
    text: "Trigonometry",
    items: [
      {
        text: "acos(x)",
        math: "acos",
        expressionText: "acos( )",
      },
      {
        text: "acosh(x)",
        math: "acosh",
        expressionText: "acosh( )",
      },
      {
        text: "acot(x)",
        math: "acot",
        expressionText: "acot( )",
      },
      {
        text: "acoth(x)",
        math: "acoth",
        expressionText: "acoth( )",
      },
      {
        text: "acsc(x)",
        math: "acsc",
        expressionText: "acsc( )",
      },
      {
        text: "acsch(x)",
        math: "acsch",
        expressionText: "acsch( )",
      },
      {
        text: "asec(x)",
        math: "asec",
        expressionText: "asec( )",
      },
      {
        text: "asech(x)",
        math: "asech",
        expressionText: "asech( )",
      },
      {
        text: "asin(x)",
        math: "asin",
        expressionText: "asin( )",
      },
      {
        text: "asinh(x)",
        math: "asinh",
        expressionText: "asinh( )",
      },
      {
        text: "atan(x)",
        math: "atan",
        expressionText: "atan( )",
      },
      {
        text: "atan2(y, x)",
        math: "atan2",
        expressionText: "atan2( , )",
      },
      {
        text: "atanh(x)",
        math: "atanh",
        expressionText: "atanh( )",
      },
      {
        text: "cos(x)",
        math: "cos",
        expressionText: "cos( )",
      },
      {
        text: "cosh(x)",
        math: "cosh",
        expressionText: "cosh( )",
      },
      {
        text: "cot(x)",
        math: "cot",
        expressionText: "cot( )",
      },
      {
        text: "coth(x)",
        math: "coth",
        expressionText: "coth( )",
      },
      {
        text: "csc(x)",
        math: "csc",
        expressionText: "csc( )",
      },
      {
        text: "csch(x)",
        math: "csch",
        expressionText: "csch( )",
      },
      {
        text: "sec(x)",
        math: "sec",
        expressionText: "sec( )",
      },
      {
        text: "sech(x)",
        math: "sech",
        expressionText: "sech( )",
      },
      {
        text: "sin(x)",
        math: "sin",
        expressionText: "sin( )",
      },
      {
        text: "sinh(x)",
        math: "sinh",
        expressionText: "sinh( )",
      },
      {
        text: "tan(x)",
        math: "tan",
        expressionText: "tan( )",
      },
      {
        text: "tanh(x)",
        math: "tanh",
        expressionText: "tanh( )",
      },
    ],
  },
  {
    text: "Unit",
    items: [
      {
        text: "to(x, unit)",
        math: "to",
        expressionText: "to( , )",
      },
    ],
  },
  {
    text: "Utilities",
    items: [
      {
        text: "clone(x)",
        math: "clone",
        expressionText: "clone( )",
      },
      {
        text: "hasNumericValue(x)",
        math: "hasNumericValue",
        expressionText: "hasNumericValue( )",
      },
      {
        text: "isInteger(x)",
        math: "isInteger",
        expressionText: "isInteger( )",
      },
      {
        text: "isNaN(x)",
        math: "isNaN",
        expressionText: "isNaN( )",
      },
      {
        text: "isNegative(x)",
        math: "isNegative",
        expressionText: "isNegative( )",
      },
      {
        text: "isNumeric(x)",
        math: "isNumeric",
        expressionText: "isNumeric( )",
      },
      {
        text: "isPositive(x)",
        math: "isPositive",
        expressionText: "isPositive( )",
      },
      {
        text: "isPrime(x)",
        math: "isPrime",
        expressionText: "isPrime( )",
      },
      {
        text: "isZero(x)",
        math: "isZero",
        expressionText: "isZero( )",
      },
      {
        text: "numeric(x)",
        math: "numeric",
        expressionText: "numeric( )",
      },
      {
        text: "typeOf(x)",
        math: "typeOf",
        expressionText: "typeOf( )",
      },
    ],
  },
];

export default componentTree;
